import { Checkbox } from '@mui/material';
import { RequestBookingListType } from '@src/types/booking';
import dayjs from 'dayjs';
import { useState } from 'react';
import styled from 'styled-components';

const ListWrap = styled.div`
  table,
  th,
  td {
    border: 1px solid black;
    border-collapse: collapse;
  }
  td {
    padding: 5px 10px;
    max-width: 250px;
    &:nth-of-type(7) {
      word-break: break-all;
    }
    a {
      color: red;
    }
  }
`;

type PropTypes = {
  list: RequestBookingListType[];
  onSelectListChange?: (idList: number[]) => void;
};
export default function RequestListTable({ list, onSelectListChange = () => {} }: PropTypes) {
  const [allSelect, setAllSelect] = useState(false);
  const [selectList, setSelectList] = useState<number[]>([]);
  const handleAllChecked = () => {
    if (!allSelect) {
      const newList = list.map(({ id }) => id) || [];
      setSelectList(newList);
      onSelectListChange(newList);
    } else {
      onSelectListChange([]);
      setSelectList([]);
    }
    setAllSelect(!allSelect);
  };

  const handleCheck = (id: number, checked: boolean) => {
    if (checked) {
      const newList = [...selectList, id];
      setSelectList(newList);
      if (list.length === newList.length) {
        setAllSelect(true);
      }
      onSelectListChange(newList);
    } else {
      const newList = selectList.filter(select => select !== id);
      setSelectList(newList);
      setAllSelect(false);
      onSelectListChange(newList);
    }
  };

  return (
    <ListWrap>
      <table>
        <thead>
          <tr>
            <td>
              <Checkbox onChange={handleAllChecked} checked={allSelect} />
            </td>
            <td>예약 장소</td>
            <td>예약일, 시간</td>
            <td>예약자 이름</td>
            <td>예약자 전화번호</td>
            <td>예약자 email</td>
            {/* <td>Cookie</td> */}
            <td>Result</td>
            <td>확인</td>
          </tr>
        </thead>
        <tbody>
          {list.map(request => {
            const response = request.response && JSON.parse(request.response);
            const result = response ? !response.data.error : undefined;
            const url = response?.data?.submitBooking?.url?.pc;
            return (
              <tr key={request.id}>
                <td>
                  <Checkbox
                    onChange={(e, checked) => handleCheck(request.id, checked)}
                    checked={selectList.some(id => id === request.id)}
                  />
                </td>
                <td>{request.item_name}</td>
                <td>
                  {JSON.parse(request.biz_item_daily_price_json).map(item => {
                    const keys = Object.keys(item);
                    return keys.map(key => (
                      <p key={key}>{dayjs(key).tz('Asia/Seoul').format('YYYY-MM-DD (ddd) HH:mm')}</p>
                    ));
                  })}
                </td>
                <td>{request.name}</td>
                <td>{request.phone}</td>
                <td>{request.email}</td>
                {/* <td>{request.cookie || ''}</td> */}
                <td>
                  {result === undefined ? '' : result ? '성공' : '실패'} <br />
                  {url ? (
                    <a href={url} target="_blank" rel="noreferrer">
                      결제하기
                    </a>
                  ) : (
                    ''
                  )}
                </td>
                <td>{request.confirm ? (request.confirm === 1 ? '확인' : '거절') : ''}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </ListWrap>
  );
}
